import { inject, injectable } from "@launchtray/tsyringe-async";
import { ILogger } from "../../cityversetycoon/logger/ILogger";

type ConnectionType = "auto-connect" | "connect";

type ConnectionEvent = {
    connectionType: ConnectionType;
    storageKeys: Record<string, string>;
}

enum ThirdWebEvent {
    MISSING_AUTH_TOKEN = "Missing auth token"
}

@injectable()
export class ThirdWebAnalytic {
    private static readonly KEYS_TO_LOG = [
        "thirdwebEwsWalletUserId",
        "walletToken"
    ];

    private readonly connectionEvents: Array<ConnectionEvent>

    public constructor(
        @inject("ILogger")
        private readonly logger: ILogger
    ) {
        this.connectionEvents = [];
    }

    public trackConnectionEvent(connectionType: ConnectionType): void {
        const connectionEvent: ConnectionEvent = {
            connectionType,
            storageKeys: this.getStorageKeysRecords()
        };
        this.connectionEvents.push(connectionEvent);
        this.logger.debug(`Connection event holded for future events: ${JSON.stringify(connectionEvent)}`);
    }

    public trackMissingAuthTokenEvent(): void {
        const eventData: Record<string, string> = {};
        for (let i = 0; i < this.connectionEvents.length; i++) {
            const connectionEvent = this.connectionEvents[i];
            const eventKey = `[${connectionEvent.connectionType} #${i}]`;
            for (const key in connectionEvent.storageKeys) {
                eventData[`${eventKey} ${key}`] = connectionEvent.storageKeys[key];
            }
        }

        this.logger.event(ThirdWebEvent.MISSING_AUTH_TOKEN, {
            connectionEvents: JSON.stringify(this.connectionEvents),
            ...{
                ...eventData,
                ...this.getStorageKeysRecords()
            }
        });
    }

    private getStorageKeysRecords(): Record<string, string> {
        const result: Record<string, string> = {};
        const storageKeys = Object.keys(localStorage);
        for (const key of ThirdWebAnalytic.KEYS_TO_LOG) {
            const storageKey = storageKeys.find((storageKey) => storageKey.includes(key));
            if (storageKey != null) {
                result[storageKey] = localStorage[storageKey];
            }
        }
        return result;
    }
}